import * as React from 'react'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import Typography from '@mui/material/Typography'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { DeckMappToolTip } from 'components/tooltip/DeckMappToolTip'
import { Box } from '@mui/material'

export const DeckAccordion = ({
  title,
  defaultExpanded = true,
  onChange,
  showTooltip = true,
  tooltipTitle,
  titleComponent,
  children
}) => {
  return (
    <Accordion
      className={`deck-accordion`}
      defaultExpanded={defaultExpanded}
      onChange={(_, expanded) => onChange?.(expanded)}>
      <AccordionSummary
        sx={{
          minHeight: 'min-content'
        }}
        expandIcon={<ExpandMoreIcon />}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h5" component="h5">
            {title}
            {showTooltip && (
              <DeckMappToolTip
                title={
                  tooltipTitle ??
                  'Interactive Bill of Materials (BOM). Selecting items on the BOM will highlight this material on the Deck Layout view. Selecting panels on the deck layout will highlight the material on the BOM'
                }
              />
            )}
          </Typography>

          {titleComponent}
        </Box>
      </AccordionSummary>

      <AccordionDetails>{children}</AccordionDetails>
    </Accordion>
  )
}
